import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";
import Field from "./Field";
import { passwordStrength } from "./validators";

/** Step 3: the owner's own login. */
export default function OwnerStep({ owner, patch, errors, onBlur }) {
  const [show, setShow] = useState(false);
  const strength = passwordStrength(owner.password);
  const input = (name, extra = {}) => ({
    id: `f-${name}`,
    value: owner[name] || "",
    onChange: (e) => patch({ [name]: e.target.value }),
    onBlur: () => onBlur(name),
    className: "auth-input",
    "aria-invalid": errors[name] ? true : undefined,
    "aria-describedby": `f-${name}-msg`,
    ...extra,
  });

  return (
    <div>
      <h2 className="reg-title">Create your owner account</h2>
      <p className="reg-sub">You will use this email and password to sign in and manage the property.</p>

      <div className="reg-row">
        <Field id="f-firstName" label="First name" error={errors.firstName}>
          <input {...input("firstName", { autoComplete: "given-name" })} />
        </Field>
        <Field id="f-lastName" label="Last name" error={errors.lastName}>
          <input {...input("lastName", { autoComplete: "family-name" })} />
        </Field>
      </div>

      <Field id="f-email" label="Email" error={errors.email} hint="We send your confirmation link here">
        <input {...input("email", { type: "email", inputMode: "email", autoComplete: "username" })} />
      </Field>

      <div className="reg-row">
        <Field id="f-password" label="Password" error={errors.password} hint={!owner.password ? "At least 8 characters" : undefined}>
          <div className="auth-password">
            <input {...input("password", { type: show ? "text" : "password", autoComplete: "new-password" })} />
            <button type="button" className="auth-eye" aria-label={show ? "Hide password" : "Show password"} onClick={() => setShow((s) => !s)}>
              {show ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
          {owner.password && (
            <div className={`pw-meter s${strength.score}`} aria-live="polite">
              <span className="pw-bars" aria-hidden="true">
                <i />
                <i />
                <i />
                <i />
              </span>
              <span className="pw-label">{strength.label}</span>
            </div>
          )}
        </Field>
        <Field id="f-confirmPassword" label="Confirm password" error={errors.confirmPassword}>
          <input {...input("confirmPassword", { type: show ? "text" : "password", autoComplete: "new-password" })} />
        </Field>
      </div>

      <div className={`auth-check ${errors.agree ? "has-error" : ""}`}>
        <label>
          <input type="checkbox" checked={!!owner.agree} onChange={(e) => patch({ agree: e.target.checked })} onBlur={() => onBlur("agree")} />
          <span>
            I agree to the{" "}
            <Link to="/legal/terms" target="_blank">
              Terms
            </Link>{" "}
            and{" "}
            <Link to="/legal/privacy" target="_blank">
              Privacy Policy
            </Link>
          </span>
        </label>
        {errors.agree && (
          <p className="auth-error" role="alert">
            {errors.agree}
          </p>
        )}
      </div>
    </div>
  );
}
